/* eslint-disable complexity */
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Components from '../../components';
import Cookies from '../../components/Cookies/Cookies';
import Loader from '../../components/Loader/Loader';
import visibleOnRelease from '../../config/visibleOnRelease';
import Context from '../../context';
import Hooks from '../../hooks';
import { fetchAnnouncements } from '../../modules/location/announcements/operations';
import { fetchBillboards } from '../../modules/location/billboards/operations';
import { fetchSettings } from '../../modules/location/settings/operations';
import { fetchWeather } from '../../modules/location/weather/operations';
import ScrollToTop from './ScrollToTop';
import './Start.scss';
import 'react-toastify/dist/ReactToastify.css';
import Icons from '../../assets/icons';
import OutOfService from '../../components/OutOfService/OutOfService';
import { useTranslation } from 'react-i18next';
// import baner from '../../assets/images/baner/baner.png';

import baner1 from '../../assets/images/baner/1.png';
import baner2 from '../../assets/images/baner/2.png';
import baner3 from '../../assets/images/baner/3.png';
import { BergWeather } from '@berg-regions/berg-components';

// eslint-disable-next-line complexity
const Start = () => {
  const dispatch = Hooks.useAppDispatch();
  const { t } = useTranslation('common');
  const loc = useLocation().pathname;
  const [location, setLocation] = useState(loc);

  useEffect(() => {
    setLocation(loc);
  }, [location, loc]);

  useEffect(() => {
    dispatch(fetchSettings());
    dispatch(fetchAnnouncements());
    dispatch(fetchBillboards());

    const handleFetchWeather = () => {
      dispatch(fetchWeather());
    };

    handleFetchWeather();

    const weatherIntervalIndex = setInterval(handleFetchWeather, 300_000);

    return () => {
      clearInterval(weatherIntervalIndex);
    };
  }, [dispatch]);

  const { weatherCode, temperature, sunrise, sunset, localTime } =
    Hooks.useAppSelector((s) => s.weather.data) ?? {};

  useEffect(() => {
    const buildType = process.env.REACT_APP_BUILD_TYPE;

    let title, description, ogImageUrl, favicon, ogDescription, ogTitle, ogName;
    switch (buildType) {
      case 'BRAMA':
        title = 'Brama w Gorce - Niezwykła podróż w serce przyrody';
        description =
          'Poznaj Centrum Edukacyjno-Przyrodnicze Brama w Gorce. Idealne miejsce do aktywnego wypoczynku i poznawania bogactwa przyrody w sercu Podhala. Odkryj dolinę potoku Kowaniec i lokalne atrakcje przyrodnicze dostępne przez cały rok dla każdego, w tym osób z niepełnosprawnościami.';
        ogImageUrl = 'https://bramawgorce.bergregions.pl/assets/logo_gorce.png';
        (ogDescription = 'Brama w Gorce - Niezwykła podróż w serce przyrody'),
          (ogTitle = 'Brama w Gorce - Niezwykła podróż w serce przyrody'),
          (ogName = 'Brama w Gorce - Niezwykła podróż w serce przyrody'),
          (favicon = '/assets/favicon/favicon-32x32.png');
        break;
      case 'FLISACY':
        title = 'Flisacy - Przygoda na rzece';
        description =
          'Spływ Przełomem Dunajca to największa atrakcja turystycznych polskich gór. Podczas spływu tratwami na własne oczy zobaczysz piękno Pienin, a flisackie opowieści dopełnią całej wyprawy. Pływamy co roku od pierwszego kwietnia do ostatniego października.';
        ogImageUrl = 'https://flisacy.bergregions.pl/assets/logo_flisacy.png';
        ogDescription = 'Flisacy - Przygoda na rzece';
        ogTitle = 'Flisacy - Przygoda na rzece';
        ogName = 'Flisacy - Przygoda na rzece';
        favicon = '/assets/favicon/favicon_flisacy_32x32.png';
        break;
      case 'POLANA':
        title = 'Stacja Narciarska Długa Polana | Nowy Targ';
        description =
          'Ośrodek położony u stóp Gorców w Nowym Targu. Słynny mikroklimat stacji sprawia, że warunki śniegowe są tutaj zawsze idealne, a trasy perfekcyjnie przygotowane.';
        ogImageUrl = 'https://polana.bergregions.pl/assets/logo_polana.png';
        ogDescription = 'Stacja Narciarska Długa Polana | Nowy Targ';
        ogTitle = 'Stacja Narciarska Długa Polana | Nowy Targ';
        ogName = 'Stacja Narciarska Długa Polana | Nowy Targ';
        favicon = '/assets/favicon/favicon_polana_32x32.png';
        break;
      case 'POTOK':
        title =
          'Termy Gorący Potok | Szaflary | Baseny termalne na Podhalu z gorącą siarkową wodą | Termy, apartamenty, spa';
        description =
          'Gorący Potok to kompleks term z kilkunastoma unikalnymi basenami zewnętrznymi z naturalną, surową wodą siarkową, w których każdy znajdzie atrakcje dla siebie. Strefa basenowa, strefa spa, noclegi to wszystko dostępne na Podhalu w Szaflarach na termach Gorący Potok';
        ogImageUrl = 'https://potok.bergregions.pl/assets/logo_potok.png';
        ogDescription =
          'Termy Gorący Potok | Szaflary | Baseny termalne na Podhalu z gorącą siarkową wodą | Termy, apartamenty, spa';
        ogTitle =
          'Termy Gorący Potok | Szaflary | Baseny termalne na Podhalu z gorącą siarkową wodą | Termy, apartamenty, spa';
        ogName =
          'Termy Gorący Potok | Szaflary | Baseny termalne na Podhalu z gorącą siarkową wodą | Termy, apartamenty, spa';
        favicon = '/assets/favicon/favicon_potok_32x32.png';
        break;
      case 'RABKOLAND':
        title = 'Rabkoland - Rodzinny Park Rozrywki';
        description =
          'Rabkoland to największy park rozrywki w Małopolsce. Oferuje ponad 40 atrakcji dla dzieci i dorosłych, w tym roller coastery, karuzele i wiele innych. Idealne miejsce na rodzinny wypoczynek.';
        ogImageUrl =
          'https://rabkoland.bergregions.pl/assets/logo_rabkoland.png';
        ogDescription = 'Rabkoland - Rodzinny Park Rozrywki';
        ogTitle = 'Rabkoland - Rodzinny Park Rozrywki';
        ogName = 'Rabkoland - Rodzinny Park Rozrywki';
        favicon = '/assets/favicon/favicon_rabkoland_32x32.png';
        break;
      case 'STARTVELO':
        title = 'Startvelo - Twoja przygoda na dwóch kółkach';
        description =
          'Startvelo to miejsce, gdzie pasja do rowerów spotyka się z naturą. Oferujemy szeroki wybór tras rowerowych, wypożyczalnię sprzętu i wiele atrakcji dla miłośników dwóch kółek.';
        ogImageUrl =
          'https://startvelo.bergregions.pl/assets/logo_startvelo.jpg';
        ogDescription = 'Startvelo - Twoja przygoda na dwóch kółkach';
        ogTitle = 'Startvelo - Twoja przygoda na dwóch kółkach';
        ogName = 'Startvelo - Twoja przygoda na dwóch kółkach';
        favicon = '/assets/favicon/favicon_startvelo_32x32.png';
        break;
      default:
        title = 'Niezwykła podróż - Odkrywaj z nami przyrodę';
        description = 'Niezwykła podróż - Odkrywaj z nami przyrodę';
        ogImageUrl = 'https://default.bergregions.pl/assets/logo_berg.png';
        ogDescription = 'Niezwykła podróż - Odkrywaj z nami przyrodę';
        ogTitle = 'Niezwykła podróż - Odkrywaj z nami przyrodę';
        ogName = 'Niezwykła podróż - Odkrywaj z nami przyrodę';
        favicon = '/assets/favicon/favicon-default-32x32.png';
    }

    document.title = title;

    // Ustawianie metadanych opisu strony
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }

    // Ustawianie favicona
    const linkFavicon = document.querySelector('link[rel="icon"]');
    if (linkFavicon) {
      linkFavicon.setAttribute('href', favicon);
    }

    // Ustawianie metadanych obrazu Open Graph
    const metaOgImageUrl = document.querySelector('meta[property="og:image"]');
    if (metaOgImageUrl) {
      metaOgImageUrl.setAttribute('content', ogImageUrl);
    }

    const metaOgDescription = document.querySelector(
      'meta[property="og:description"]'
    );
    if (metaOgDescription) {
      metaOgDescription.setAttribute('content', ogDescription);
    }

    const metaOgTitle = document.querySelector('meta[property="og:image"]');
    if (metaOgTitle) {
      metaOgTitle.setAttribute('content', ogTitle);
    }

    const metaOgISitName = document.querySelector('meta[property="og:image"]');
    if (metaOgISitName) {
      metaOgISitName.setAttribute('content', ogName);
    }
  }, []);

  return (
    <>
      <Context.SeasonTheme>
        <header id="header">
          {/* <div className="w-fit justify-self-center bg-white">
            <img src={baner} className="w-full"></img>
          </div> */}
          <div className="w-full justify-self-center bg-white p-4 lg:py-10 lg:px-64 flex flex-col gap-5 sm:gap-10">
            <div className="flex flex-row items-center z-[2] justify-between">
              <div className="flex flex-row gap-2 sm:gap-7 items-center">
                <div className="justify-items-start">
                  <h1 className="text-lg sm:text-4xl font-bold">
                    {t('podhale_baner_top')}
                  </h1>
                  <h2 className="text-base sm:text-2xl font-semibold">
                    {t('podhale_baner_bottom')}
                  </h2>
                </div>{' '}
              </div>
              <div className="flex flex-row gap-8 items-center">
                <div className="hidden sm:block text-[18px] font-semibold">
                  {/* {visibleOnRelease.weather && <Components.Weather />} */}
                  <BergWeather
                    weatherCode={weatherCode}
                    temperature={temperature}
                    sunrise={sunrise}
                    sunset={sunset}
                    localTime={localTime}
                    iconColor="black"
                    textColor="black"
                    color="black"
                    imgSize={42}
                    tempFontSize={18}
                    tempFontWeight={700}
                    className="justify-center h-full flex flex-row gap-2 items-center"
                  />
                </div>
                <Components.LanguageDropdown />
              </div>
            </div>
            <div className="flex flex-row justify-between gap-1 sm:gap-8 items-center z-[1]">
              <div>
                <img
                  src={baner1}
                  alt="baner1"
                  className="h-[3em] sm:h-[7rem]"
                />
                <div className="mt-[-8px] sm:mt-0">
                  <strong className="font-bold text-[10px] sm:text-[18px] uppercase">
                    {t('baner_left_top')}
                  </strong>
                  <p className="text-[10px] sm:text-[16px] leading-4 sm:leading-6">
                    {t('baner_left_bottom')}
                  </p>
                </div>
              </div>

              <div>
                <img
                  src={baner2}
                  alt="baner2"
                  className="h-[3rem] sm:h-[7rem]"
                />
                <div className="mt-[-8px] sm:mt-0">
                  <strong className="font-bold text-[10px] sm:text-[18px] uppercase">
                    {t('baner_center_top')}
                  </strong>
                  <p className="text-[10px] sm:text-[16px] leading-4 sm:leading-6">
                    {t('baner_center_bottom')}
                  </p>
                </div>
              </div>
              <div>
                <img
                  src={baner3}
                  alt="baner3"
                  className="h-[3rem] sm:h-[7rem]"
                />
                <div className="mt-[-8px] sm:mt-0">
                  <strong className="font-bold text-[10px] sm:text-[18px] uppercase">
                    {t('baner_right_top')}
                  </strong>
                  <p className="text-[10px] sm:text-[16px] leading-4 sm:leading-6">
                    {t('baner_right_bottom')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </header>

        <Context.Navigation>
          <div id="sub-header"></div>
          <main>
            <Outlet />
          </main>
        </Context.Navigation>

        <footer>
          <Components.Footer />
        </footer>
        {location !== '/cart' &&
          location !== '/cart/order-data' &&
          location !== '/cart/summary' &&
          location !== '/payment/status' && <Components.BasketStickyCTA />}
        {visibleOnRelease.planStay && <Components.StickyCTA />}
        <Loader />
      </Context.SeasonTheme>
      <ScrollToTop />
      {/* <Billboard /> */}
      <Cookies />
      {location !== '/activities/therms-tickets' &&
        location !== '/activities/accommodation' &&
        location !== '/activities/parking' &&
        visibleOnRelease.outOfService && <OutOfService />}
      <ToastContainer
        position="bottom-left"
        autoClose={6000}
        hideProgressBar={true}
        newestOnTop={true}
        closeButton={({ closeToast }) => (
          <button onClick={closeToast} className="berg-styles-snackbar-close">
            <Icons.Xmark />
          </button>
        )}
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
};

export default Start;
